export default __webpack_public_path__ + "static/media/813.43b4ceb1.png";